module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@2x-22474bd7b1fd7e4bf9b9c61197216a66.png";